<template>
  <div>
    <MultiSearchHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">

      <MultiSearchFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              :createData="createData"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <MultiSearchTable
              :createData="createData"
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import MultiSearchHead from "./MultiSearchHead/MultiSearchHead";
  import MultiSearchTable from "./MultiSearchTable/MultiSearchTable";
  import MultiSearchFilter from "./MultiSearchFilter/MultiSearchFilter";

  export default {
    name: "MultiSearchTableUser",

    components: {
      MultiSearchHead,
      MultiSearchTable,
      MultiSearchFilter,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
      createData: Object,
    },

    data(){
      return{
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },
    }
  }
</script>

<style scoped>

</style>
